<template>
	<div class="flex w-full justify-center mb-6 sm:my-12">
		<div class="w-full max-w-2xl lg:max-w-3xl xl:max-w-5xl">
			<div class="bg-transparent md:bg-ihh-dark-salmon rounded-lg">
				<div class="p-4 sm:p-8 md:relative md:translate-x-6 md:-translate-y-6 bg-ihh-purple rounded-lg mx-4 sm:mx-6 md:mx-0 border shadow-lg">
					<div class="text-start text-ihh-midnight-gray">
						<div class="text-2xl sm:text-3xl text-ihh-midnight-gray font-semibold tracking-wide pb-4">In His Hands</div>
						<div class="text-base md:text-lg leading-8">
							<span class="font-semibold">In His Hands Birth Supply</span> is your source for the widest selection of natural
							<span class="font-semibold">pregnancy, birth & postpartum items.</span> Featuring popular brands such as
							<span class="font-semibold">Earth Mama, Wishgarden, Frida Mom, Earthley, Birth Pool in a Box, Mountain Meadow Herbs,</span> and many more we are
							your one-stop-shop for everything you need for a natural birth. We provide a
							<span class="font-semibold">custom birth kit service</span> for midwives and a wide selection of simple but essential birth supplies. We also sell
							a large variety of <span class="font-semibold">midwifery equipment</span> including all major brands of
							<span class="font-semibold">fetal dopplers, Masimo Pulse Oximeters, oxygen supplies, diagnostic tests,</span> and much more. We are a
							<span class="font-semibold">family-owned</span> and operated business located in Central Texas and shipping worldwide. Since 1999 we have been
							known for our <span class="font-semibold">fast shipping, kind, and reliable customer service, and wide selection of items.</span> <br />Thanks
							for stopping by our store!
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
